"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
const MethodConfig_1 = __importDefault(require("../../interface/MethodConfig"));
const config_1 = __importDefault(require("../../config"));
class BtcFee {
    constructor() {
        this.requireLevel = config_1.default.REQUIRE_LEVEL.COMPLETELY;
        this.id = 'bifi.btcFee';
        this.entryPointID = 'bifi.btcfund';
        this.defaultDecimals = new bifrost_number_1.default('10').pow(config_1.default.default.decimals);
    }
    getMethodProps() {
        return [
            new MethodConfig_1.default('bifi.btcInflowFee', [], 'bifi.btcfund'),
            new MethodConfig_1.default('bifi.btcOutflowFee', [], 'bifi.btcfund')
        ];
    }
    proccessCallResponse(responses) {
        const rawInflow = responses[0] || [];
        const rawOutflow = responses[1] || [];
        const inflow = {
            rate: new bifrost_number_1.default(rawInflow[0] || '0').div(this.defaultDecimals).toStr(),
            min: '0'
        };
        const outflow = {
            rate: new bifrost_number_1.default(rawOutflow[0] || '0').div(this.defaultDecimals).toStr(),
            min: new bifrost_number_1.default(rawOutflow[1] || '0').div(this.defaultDecimals).toStr()
        };
        return {
            inflow,
            outflow
        };
    }
}
exports.default = BtcFee;
;
//# sourceMappingURL=BtcFee.js.map